import { c as _c } from "react/compiler-runtime";
import { Check, ChevronsUpDown, Plus, X } from "lucide-react";
import * as React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem } from "@/components/ui/command";
import { Input } from "@/components/ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/libs/shadui";
export type OptionType = {
  label: string;
  value: string;
};
interface MultiSelectProps {
  options: OptionType[];
  selected: string[];
  onChange: React.Dispatch<React.SetStateAction<string[]>>;
  className?: string;
  isDirty?: boolean;
  allowAddNew?: boolean;
  onAddNewOption?: (newOption: OptionType) => void;
  placeholder?: string;
  disabled?: boolean;
}
function MultiSelect(t0) {
  const $ = _c(101);
  let allowAddNew;
  let className;
  let isDirty;
  let onAddNewOption;
  let onChange;
  let options;
  let placeholder;
  let props;
  let selected;
  let t1;
  if ($[0] !== t0) {
    ({
      options,
      selected,
      onChange,
      className,
      isDirty,
      allowAddNew,
      onAddNewOption,
      placeholder,
      disabled: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = allowAddNew;
    $[2] = className;
    $[3] = isDirty;
    $[4] = onAddNewOption;
    $[5] = onChange;
    $[6] = options;
    $[7] = placeholder;
    $[8] = props;
    $[9] = selected;
    $[10] = t1;
  } else {
    allowAddNew = $[1];
    className = $[2];
    isDirty = $[3];
    onAddNewOption = $[4];
    onChange = $[5];
    options = $[6];
    placeholder = $[7];
    props = $[8];
    selected = $[9];
    t1 = $[10];
  }
  const disabled = t1 === undefined ? false : t1;
  const [open, setOpen] = React.useState(false);
  const [newItemInput, setNewItemInput] = React.useState("");
  let t2;
  let t3;
  if ($[11] !== disabled) {
    t2 = () => {
      if (disabled) {
        setOpen(false);
      }
    };
    t3 = [disabled];
    $[11] = disabled;
    $[12] = t2;
    $[13] = t3;
  } else {
    t2 = $[12];
    t3 = $[13];
  }
  React.useEffect(t2, t3);
  let t4;
  if ($[14] !== onChange || $[15] !== selected) {
    t4 = item => {
      onChange(selected.filter(i => i !== item));
    };
    $[14] = onChange;
    $[15] = selected;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const handleUnselect = t4;
  let t5;
  if ($[17] !== newItemInput || $[18] !== onAddNewOption || $[19] !== onChange || $[20] !== options || $[21] !== selected) {
    t5 = () => {
      if (newItemInput.trim() && !options.find(opt => opt.value === newItemInput.trim())) {
        const newOption = {
          label: newItemInput.trim(),
          value: newItemInput.trim()
        };
        onAddNewOption?.(newOption);
        onChange([...selected, newItemInput.trim()]);
        setNewItemInput("");
      }
    };
    $[17] = newItemInput;
    $[18] = onAddNewOption;
    $[19] = onChange;
    $[20] = options;
    $[21] = selected;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  const addNewItem = t5;
  let T0;
  let T1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[23] !== disabled || $[24] !== handleUnselect || $[25] !== isDirty || $[26] !== open || $[27] !== options || $[28] !== placeholder || $[29] !== props || $[30] !== selected) {
    let t19;
    if ($[46] !== options) {
      t19 = (a, b) => {
        const aOption = options.find(o => o.value === a);
        const bOption = options.find(o_0 => o_0.value === b);
        return aOption?.label.localeCompare(bOption?.label ?? "") ?? 0;
      };
      $[46] = options;
      $[47] = t19;
    } else {
      t19 = $[47];
    }
    const sortedSelected = [...selected].sort(t19);
    T1 = Popover;
    t16 = disabled ? false : open;
    if ($[48] !== disabled) {
      t17 = nextOpen => {
        if (!disabled) {
          setOpen(nextOpen);
        }
      };
      $[48] = disabled;
      $[49] = t17;
    } else {
      t17 = $[49];
    }
    t18 = props;
    T0 = PopoverTrigger;
    t15 = true;
    t8 = "combobox";
    t9 = disabled ? false : open;
    t10 = disabled;
    t11 = disabled ? -1 : 0;
    const t20 = isDirty ? "border-orange-300" : "border-input";
    const t21 = disabled && "cursor-not-allowed opacity-50";
    if ($[50] !== t20 || $[51] !== t21) {
      t12 = cn("flex h-max w-full cursor-pointer items-center justify-between rounded-md border bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", t20, t21);
      $[50] = t20;
      $[51] = t21;
      $[52] = t12;
    } else {
      t12 = $[52];
    }
    if ($[53] !== disabled || $[54] !== open) {
      t13 = () => {
        if (!disabled) {
          setOpen(!open);
        }
      };
      t14 = e => {
        if (disabled) {
          return;
        }
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          setOpen(!open);
        }
      };
      $[53] = disabled;
      $[54] = open;
      $[55] = t13;
      $[56] = t14;
    } else {
      t13 = $[55];
      t14 = $[56];
    }
    t6 = "flex flex-wrap gap-1";
    t7 = sortedSelected.length > 0 ? sortedSelected.map((item_0, i_0) => {
      const option = options.find(o_1 => o_1.value === item_0);
      return <Badge variant="secondary" key={`${item_0}-${i_0}`} className="mr-1 mb-1" onClick={() => {
        if (!disabled) {
          handleUnselect(item_0);
        }
      }}>{option?.label ?? item_0}<button type="button" disabled={disabled} className="ml-1 rounded-full outline-hidden ring-offset-background focus:ring-2 focus:ring-ring focus:ring-offset-2" onMouseDown={_temp} onClick={() => handleUnselect(item_0)} aria-label={`Remove ${option?.label ?? item_0}`}><X className="h-3 w-3 text-muted-foreground hover:text-foreground" /></button></Badge>;
    }) : <span className="text-muted-foreground">{placeholder || "Select options..."}</span>;
    $[23] = disabled;
    $[24] = handleUnselect;
    $[25] = isDirty;
    $[26] = open;
    $[27] = options;
    $[28] = placeholder;
    $[29] = props;
    $[30] = selected;
    $[31] = T0;
    $[32] = T1;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
    $[42] = t6;
    $[43] = t7;
    $[44] = t8;
    $[45] = t9;
  } else {
    T0 = $[31];
    T1 = $[32];
    t10 = $[33];
    t11 = $[34];
    t12 = $[35];
    t13 = $[36];
    t14 = $[37];
    t15 = $[38];
    t16 = $[39];
    t17 = $[40];
    t18 = $[41];
    t6 = $[42];
    t7 = $[43];
    t8 = $[44];
    t9 = $[45];
  }
  let t19;
  if ($[57] !== t6 || $[58] !== t7) {
    t19 = <div className={t6}>{t7}</div>;
    $[57] = t6;
    $[58] = t7;
    $[59] = t19;
  } else {
    t19 = $[59];
  }
  let t20;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <ChevronsUpDown className="h-4 w-4 shrink-0 opacity-50" />;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  let t21;
  if ($[61] !== t10 || $[62] !== t11 || $[63] !== t12 || $[64] !== t13 || $[65] !== t14 || $[66] !== t19 || $[67] !== t8 || $[68] !== t9) {
    t21 = <div role={t8} aria-expanded={t9} aria-disabled={t10} tabIndex={t11} className={t12} onClick={t13} onKeyDown={t14}>{t19}{t20}</div>;
    $[61] = t10;
    $[62] = t11;
    $[63] = t12;
    $[64] = t13;
    $[65] = t14;
    $[66] = t19;
    $[67] = t8;
    $[68] = t9;
    $[69] = t21;
  } else {
    t21 = $[69];
  }
  let t22;
  if ($[70] !== T0 || $[71] !== t15 || $[72] !== t21) {
    t22 = <T0 asChild={t15}>{t21}</T0>;
    $[70] = T0;
    $[71] = t15;
    $[72] = t21;
    $[73] = t22;
  } else {
    t22 = $[73];
  }
  let t23;
  let t24;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <CommandInput placeholder="Search ..." />;
    t24 = <CommandEmpty>No items found.</CommandEmpty>;
    $[74] = t23;
    $[75] = t24;
  } else {
    t23 = $[74];
    t24 = $[75];
  }
  let t25;
  if ($[76] !== onChange || $[77] !== options || $[78] !== selected) {
    let t26;
    if ($[80] !== onChange || $[81] !== selected) {
      t26 = (option_0, i_1) => <CommandItem key={`${option_0.value}-${i_1}`} value={option_0.label} keywords={[option_0.label]} onSelect={() => {
        onChange(selected.includes(option_0.value) ? selected.filter(item_1 => item_1 !== option_0.value) : [...selected, option_0.value]);
        setOpen(true);
      }}><Check className={cn("mr-2 h-4 w-4", selected.includes(option_0.value) ? "opacity-100" : "opacity-0")} />{option_0.label}</CommandItem>;
      $[80] = onChange;
      $[81] = selected;
      $[82] = t26;
    } else {
      t26 = $[82];
    }
    t25 = options.map(t26);
    $[76] = onChange;
    $[77] = options;
    $[78] = selected;
    $[79] = t25;
  } else {
    t25 = $[79];
  }
  let t26;
  if ($[83] !== t25) {
    t26 = <CommandGroup className="max-h-64 overflow-auto">{t25}</CommandGroup>;
    $[83] = t25;
    $[84] = t26;
  } else {
    t26 = $[84];
  }
  let t27;
  if ($[85] !== addNewItem || $[86] !== allowAddNew || $[87] !== disabled || $[88] !== newItemInput) {
    t27 = allowAddNew && <div className="border-t p-2"><div className="flex items-center space-x-2"><Input placeholder="Add new option..." value={newItemInput} disabled={disabled} onChange={e_1 => setNewItemInput(e_1.target.value)} onKeyDown={e_2 => {
          if (e_2.key === "Enter") {
            e_2.preventDefault();
            addNewItem();
          }
        }} className="h-8" /><Button size="sm" onClick={addNewItem} disabled={disabled || !newItemInput.trim()} className="h-8 w-8 p-0"><Plus className="h-4 w-4" /></Button></div></div>;
    $[85] = addNewItem;
    $[86] = allowAddNew;
    $[87] = disabled;
    $[88] = newItemInput;
    $[89] = t27;
  } else {
    t27 = $[89];
  }
  let t28;
  if ($[90] !== className || $[91] !== t26 || $[92] !== t27) {
    t28 = <PopoverContent className="w-full p-0"><Command className={className}>{t23}{t24}{t26}{t27}</Command></PopoverContent>;
    $[90] = className;
    $[91] = t26;
    $[92] = t27;
    $[93] = t28;
  } else {
    t28 = $[93];
  }
  let t29;
  if ($[94] !== T1 || $[95] !== t16 || $[96] !== t17 || $[97] !== t18 || $[98] !== t22 || $[99] !== t28) {
    t29 = <T1 open={t16} onOpenChange={t17} {...t18}>{t22}{t28}</T1>;
    $[94] = T1;
    $[95] = t16;
    $[96] = t17;
    $[97] = t18;
    $[98] = t22;
    $[99] = t28;
    $[100] = t29;
  } else {
    t29 = $[100];
  }
  return t29;
}
function _temp(e_0) {
  e_0.preventDefault();
  e_0.stopPropagation();
}
export { MultiSelect };